import React from 'react';
import { ArrowRight } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withIcon?: boolean;
  href?: string;
  trackAddToCart?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  withIcon = false,
  href,
  trackAddToCart = false,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 ease-out rounded-full focus:outline-none focus:ring-4 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 hover:-translate-y-1 active:scale-100 active:translate-y-0';
  const variants = {
    primary: 'bg-gradient-to-r from-[#E8845F] to-[#F5A574] hover:from-[#D67350] hover:to-[#E8845F] text-white shadow-lg shadow-orange-200/50 focus:ring-orange-200',
    secondary: 'bg-gradient-to-r from-[#4AAAA5] to-[#5CBFBA] hover:from-[#3B9691] hover:to-[#4AAAA5] text-white shadow-lg shadow-teal-200/50 focus:ring-teal-200',
    outline: 'bg-white/80 backdrop-blur-sm border-2 border-[#E8845F] text-[#E8845F] hover:bg-[#FFF5F0] focus:ring-orange-200'
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-sm gap-2',
    md: 'px-7 py-3.5 text-base gap-2',
    lg: 'px-9 py-4.5 text-lg gap-3'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Fire Meta Pixel AddToCart event if tracking is enabled
    if (trackAddToCart && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Kit de Rutinas Visuales Anti-Berrinches',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    if (href) {
      window.location.href = href;
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={handleClick} {...props} data-id="element-490">
      {children}
      {withIcon && <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-491" />}
    </button>;
}